export var EntityType;
(function (EntityType) {
    EntityType["Unspecified"] = "ENTITYTYPE_UNSPECIFIED";
    EntityType["Portfolio"] = "PORTFOLIO";
    EntityType["Fund"] = "FUND";
    EntityType["Manager"] = "MANAGER";
    EntityType["Asset"] = "ASSET";
    EntityType["Investor"] = "INVESTOR";
})(EntityType || (EntityType = {}));
export var DocumentUploadState;
(function (DocumentUploadState) {
    DocumentUploadState["FILE_UPLOAD_STATUS_UNSPECIFIED"] = "FILE_UPLOAD_STATUS_UNSPECIFIED";
    DocumentUploadState["FILE_UPLOAD_STATUS_UPLOAD_PENDING"] = "FILE_UPLOAD_STATUS_UPLOAD_PENDING";
    DocumentUploadState["FILE_UPLOAD_STATUS_SCAN_IN_PROGRESS"] = "FILE_UPLOAD_STATUS_SCAN_IN_PROGRESS";
    DocumentUploadState["FILE_UPLOAD_STATUS_SCAN_FAILED"] = "FILE_UPLOAD_STATUS_SCAN_FAILED";
    DocumentUploadState["FILE_UPLOAD_STATUS_SCAN_PASSED"] = "FILE_UPLOAD_STATUS_SCAN_PASSED";
    DocumentUploadState["FILE_UPLOAD_STATUS_READY"] = "FILE_UPLOAD_STATUS_READY";
    DocumentUploadState["FILE_UPLOAD_STATUS_FILE_INVALID"] = "FILE_UPLOAD_STATUS_FILE_INVALID";
    DocumentUploadState["FILE_UPLOAD_STATUS_FAILED"] = "FILE_UPLOAD_STATUS_FAILED";
    DocumentUploadState["FILE_UPLOAD_USER_CANCELED"] = "FILE_UPLOAD_USER_CANCELED";
})(DocumentUploadState || (DocumentUploadState = {}));
